/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
/* tslint:disable */
import * as i0 from '@angular/core';
import * as i1 from '@angular/common';
import * as i2 from '../../../../../src/app/common/dialog/mensaje.component';
var styles_Message = [];
export var RenderType_Message = i0.ɵcrt({ encapsulation: 2, styles: styles_Message,
    data: {} });
function View_Message_2(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 4, 'div', [['class',
                'col-sm-3 col-sm-offset-3']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                        '])),
        (_l()(), i0.ɵeld(0, null, null, 1, 'button', [['class', 'btn btn-primary btn-verMas btn-buscar'],
            ['type', 'button']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.hideMsg('OK') !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), i0.ɵted(null, ['', ''])), (_l()(),
            i0.ɵted(null, ['\n                    ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.config.okLabel;
        _ck(_v, 3, 0, currVal_0);
    });
}
function View_Message_3(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 4, 'div', [['class',
                'col-sm-3 col-sm-offset-3']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                        '])),
        (_l()(), i0.ɵeld(0, null, null, 1, 'button', [['class', 'btn btn-primary btn-verMas btn-buscar'],
            ['type', 'button']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.hideMsg('CON') !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), i0.ɵted(null, ['Continuar'])),
        (_l()(), i0.ɵted(null, ['\n                    ']))], null, null);
}
function View_Message_4(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 4, 'div', [['class',
                'col-sm-3']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                        '])), (_l()(), i0.ɵeld(0, null, null, 1, 'button', [['class', 'btn btn-default btn-buscar'],
            ['type', 'button']], null, [[null, 'click']], function (_v, en, $event) {
            var ad = true;
            var _co = _v.component;
            if (('click' === en)) {
                var pd_0 = (_co.hideMsg('CAN') !== false);
                ad = (pd_0 && ad);
            }
            return ad;
        }, null, null)), (_l()(), i0.ɵted(null, ['', ''])),
        (_l()(), i0.ɵted(null, ['\n                    ']))], null, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.config.cancelLabel;
        _ck(_v, 3, 0, currVal_0);
    });
}
function View_Message_1(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 35, 'div', [['class',
                'modal fade show in danger'], ['id', 'myModal'], ['role', 'dialog']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵeld(0, null, null, 32, 'div', [['class',
                'modal-dialog modal-msg']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵeld(0, null, null, 29, 'div', [['class', 'modal-content']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵeld(0, null, null, 5, 'div', [['class',
                'modal-header']], null, null, null, null, null)),
        (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵeld(0, null, null, 1, 'h4', [['class', 'modal-title']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['', ''])), (_l()(),
            i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵeld(0, null, null, 4, 'div', [['class', 'modal-body']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                '])), (_l()(),
            i0.ɵeld(0, null, null, 1, 'p', [], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['', ''])), (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵted(null, ['\n            '])), (_l()(), i0.ɵeld(0, null, null, 13, 'div', [['class', 'modal-footer']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                '])), (_l()(),
            i0.ɵeld(0, null, null, 10, 'div', [['class', 'row']], null, null, null, null, null)), (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_Message_2)), i0.ɵdid(16384, null, 0, i1.NgIf, [i0.ViewContainerRef,
            i0.TemplateRef], { ngIf: [0, 'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_Message_3)), i0.ɵdid(16384, null, 0, i1.NgIf, [i0.ViewContainerRef,
            i0.TemplateRef], { ngIf: [0, 'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                    '])), (_l()(), i0.ɵand(16777216, null, null, 1, null, View_Message_4)), i0.ɵdid(16384, null, 0, i1.NgIf, [i0.ViewContainerRef,
            i0.TemplateRef], { ngIf: [0, 'ngIf'] }, null), (_l()(), i0.ɵted(null, ['\n                '])), (_l()(), i0.ɵted(null, ['\n            '])),
        (_l()(), i0.ɵted(null, ['\n        '])), (_l()(), i0.ɵted(null, ['\n    '])), (_l()(), i0.ɵted(null, ['\n']))], function (_ck, _v) {
        var _co = _v.component;
        var currVal_2 = _co.config.visibleOk;
        _ck(_v, 24, 0, currVal_2);
        var currVal_3 = _co.config.visibleCon;
        _ck(_v, 27, 0, currVal_3);
        var currVal_4 = _co.config.visibleCancelar;
        _ck(_v, 30, 0, currVal_4);
    }, function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.config.titulo;
        _ck(_v, 10, 0, currVal_0);
        var currVal_1 = _co.Msg;
        _ck(_v, 16, 0, currVal_1);
    });
}
export function View_Message_0(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵand(16777216, null, null, 1, null, View_Message_1)), i0.ɵdid(16384, null, 0, i1.NgIf, [i0.ViewContainerRef,
            i0.TemplateRef], { ngIf: [0, 'ngIf'] }, null)], function (_ck, _v) {
        var _co = _v.component;
        var currVal_0 = _co.MessageIsVisible;
        _ck(_v, 1, 0, currVal_0);
    }, null);
}
export function View_Message_Host_0(_l) {
    return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, null, null, 1, 'app-message', [], null, null, null, View_Message_0, RenderType_Message)),
        i0.ɵdid(49152, null, 0, i2.Message, [], null, null)], null, null);
}
export var MessageNgFactory = i0.ɵccf('app-message', i2.Message, View_Message_Host_0, { config: 'config' }, { onClick: 'onClick' }, []);
//# sourceMappingURL=mensaje.component.ngfactory.js.map